import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export const PIPELINE_STAGES = ["New", "Contacted", "Appointment Scheduled", "Application Started", "Preapproved", "Submitted to Lender", "Closed", "Lost"];
export const STAGE_BADGE = {
  New: "bg-blue-100 text-blue-800", Contacted: "bg-indigo-100 text-indigo-800",
  "Appointment Scheduled": "bg-amber-100 text-amber-800", "Application Started": "bg-cyan-100 text-cyan-800",
  Preapproved: "bg-teal-100 text-teal-800", "Submitted to Lender": "bg-violet-100 text-violet-800",
  Closed: "bg-emerald-600 text-white", Lost: "bg-slate-200 text-slate-700",
};

export const PipelineStageSelect = ({ p, onChanged }) => {
  const [stage, setStage] = useState(p?.pipeline_stage || "New");
  useEffect(() => { setStage(p?.pipeline_stage || "New"); }, [p]);
  const change = async (v) => {
    const prev = stage;
    setStage(v);
    try { await api.patch(`/prospects/${p.id}/stage`, { stage: v }); toast.success(`Pipeline stage: ${v}`); onChanged?.(); }
    catch (e) { setStage(prev); toast.error(apiError(e)); }
  };
  return (
    <div className="mt-3" data-testid="pipeline-stage">
      <div className="mb-1 text-[10px] font-semibold uppercase tracking-wider text-slate-400">Pipeline stage</div>
      <Select value={stage} onValueChange={change}>
        <SelectTrigger className="h-9" data-testid="pipeline-stage-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          {PIPELINE_STAGES.map((s) => <SelectItem key={s} value={s} data-testid={`stage-option-${s.toLowerCase().replace(/ /g, "-")}`}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
};
